// extracted by mini-css-extract-plugin
export var container = "_65-0";
export var fallback = "_65-5";
export var fallbackIcon = "_65-6";
export var hidden = "_65-2";
export var image = "_65-3";
export var loaded = "_65-4";
export var placeholder = "_65-1";